import { render, staticRenderFns } from "./article.vue?vue&type=template&id=8bd3faa0&scoped=true&lang=pug&"
import script from "./article.vue?vue&type=script&lang=js&"
export * from "./article.vue?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./article.vue?vue&type=style&index=1&id=8bd3faa0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd3faa0",
  null
  
)

export default component.exports